import { Box, Button, Flex, Grid, Text } from "@chakra-ui/react";
import { GETLicensePayload } from "../utils";
import { DocumentIcon2 } from "components/vectors/document-icon";
import { MASTER_PRICE, VO_PRICE } from "./license-and-billing";
import { CalendarIcon } from "components/vectors/calendar-icon";
import { SettingsIcon } from "@chakra-ui/icons";
import {
  ManageLicensesModal,
  openManageLicensesModal
} from "./modals/manage-licenses-modal";

interface NextBillingProps {
  licenseData: Partial<GETLicensePayload>;
  onUpdateLicenses: (data?: GETLicensePayload) => void;
}

export function NextBilling({
  licenseData,
  onUpdateLicenses
}: NextBillingProps) {
  // Calculate nextDueDate and paymentStatus using start and end dates
  const nextDueDate = licenseData.expirationDate
    ? licenseData.expirationDate.replace(/(\d{4})-(\d{2})-(\d{2})/, "$3/$2/$1")
    : "";

  const masterRemovalPending =
    licenseData?.qtyLicenseMaster! - licenseData?.pendingQtyLicenseMaster!;

  const voRemovalPending =
    licenseData?.qtyLicenseVendedorOrOperacional! -
    licenseData?.pendingQtyLicenseVendedorOrOperacional!;

  return (
    <Box
      bg="white"
      border="1px"
      borderColor="gray.200"
      borderRadius="lg"
      px={6}
      py={4}
      gap={4}
      boxShadow="sm"
      mb={4}
    >
      <Text fontWeight="semibold" color="gray.900" mb="10px">
        Próxima cobrança
      </Text>
      <Flex
        flexDirection={{ base: "column", sm: "row" }}
        alignItems="center"
        justifyContent="space-between"
        w="100%"
      >
        <Grid
          templateColumns={"1fr 1px 1fr"}
          alignItems="center"
          gap={4}
          fontSize="sm"
          w="100%"
        >
          <Box>
            <Flex alignItems="center" fontSize={13} gap="6px">
              <Box color="gray.500">Qtd. Master: </Box>
              <Box as="span" fontWeight="medium" color={"gray.900"}>
                {licenseData?.pendingQtyLicenseMaster!}
              </Box>
              <Box as="span" fontWeight="medium" color="yellow.600">
                {licenseData?.qtyLicenseMaster! >
                licenseData?.pendingQtyLicenseMaster!
                  ? `(${masterRemovalPending} ${masterRemovalPending > 1 ? "remoções pendentes" : "remoção pendente"})`
                  : ""}
              </Box>
            </Flex>

            <Flex alignItems="center" fontSize={13} gap="6px">
              <Box color="gray.500" whiteSpace="nowrap">
                Qtd. Vendedor/Operacional:
              </Box>
              <Box fontWeight="medium" as="span" color={"gray.900"}>
                {licenseData?.pendingQtyLicenseVendedorOrOperacional!}
              </Box>
              <Box
                as="span"
                fontWeight="medium"
                color="yellow.600"
                whiteSpace="nowrap"
              >
                {licenseData?.qtyLicenseVendedorOrOperacional! >
                licenseData?.pendingQtyLicenseVendedorOrOperacional!
                  ? `(${voRemovalPending} ${voRemovalPending > 1 ? "remoções pendentes" : "remoção pendente"})`
                  : ""}
              </Box>
            </Flex>
          </Box>

          {/* DIVIDER */}
          <Box
            display={{ base: "none", sm: "block" }}
            w="1px"
            h={4}
            bg="gray.200"
          />
          {/*  */}

          <Flex flexDir="column" fontSize={13}>
            <Flex align="center" color="gray.500" gap="6px">
              <DocumentIcon2 width="12px" height="14px" />{" "}
              <Text>Valor a ser cobrado: </Text>
              <Text as="span" fontWeight="medium" color="gray.900">
                R${" "}
                {Number(
                  licenseData.pendingQtyLicenseMaster! * MASTER_PRICE +
                    licenseData.pendingQtyLicenseVendedorOrOperacional! *
                      VO_PRICE
                )
                  .toFixed(2)
                  .replace(".", ",")}
              </Text>
            </Flex>

            <Flex align="center" color="gray.500" gap="6px">
              <CalendarIcon w={3} h={3} color="gray.400" />{" "}
              <Text>Próxima cobrança:</Text>{" "}
              <Text fontWeight="medium" color="gray.900">
                {nextDueDate}
              </Text>
            </Flex>
          </Flex>
        </Grid>
      </Flex>{" "}
      <Button
        mt="10px"
        size="xs"
        leftIcon={<SettingsIcon />}
        onClick={() => openManageLicensesModal()}
      >
        Gerenciar Licença
      </Button>
      <ManageLicensesModal
        licenseData={licenseData}
        onUpdateLicenses={onUpdateLicenses}
      />
    </Box>
  );
}
